import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { BankDetailsService } from '../../../core/services/bank/bank-details/bank-details.service'
import { ContractStatusService } from '../../../core/services/contract/contract-status/contract-status.service'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatOption, MatSelect } from '@angular/material/select'
import { ProfileService } from '../../../core/services/profile/profile.service'
import { UserManagementService } from '../../../core/services/user-management/user-management.service'

@Component({
  selector: 'employee-management',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelect,
    MatOption,
  ],
  templateUrl: './employee-management-edit.component.html',
  styleUrl: './employee-management-edit.component.scss',
  providers: [LegalEntityClientService],
  standalone: true,
})
export class EmployeeManagementEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private userManagementService: UserManagementService,
    private profileService: ProfileService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<EmployeeManagementEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseEdit = new EventEmitter()
  isEditing: boolean = false
  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  profilesList: any[] = []
  ngOnInit(): void {
    this.listProfiles()
    if (this.data.item.isUsuario === 'S') {
      this.isEditing = true
    }
      this.itemEdit = this.data.item
    this.createForm()
  }
  listProfiles() {
    this.profileService.listProfileFilter().subscribe({
      next: (response: ResponseRequestModel) => {
        if (response.data) {
          this.profilesList = response.data
        }
        this.snackbar.success('Perfis listados com sucesso')
      },
      error: (err: ErrorRequestModel) => {
        this.snackbar.errorRequest(err)
      },
      complete: () => {},
    })
  }
  verifyFunction() {
    this.isEditing ? this.updateItem() : this.createItem()
  }
  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.userManagementService.editUser(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }
  createItem() {
    this.loading = true
    const model = this.createModel()
    this.userManagementService.createEmployee(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }
  close() {
    this.dialogRef.close()
  }

  createModel() {
    if (this.isEditing) {
      return {
        id: this.itemEdit.usuarioId,
        email: this.form.controls['email'].value,
        idPerfil: this.form.controls['profile'].value,
        idStatus: this.itemEdit.usuario_status,
      }
    } else {
      return {
        Email: this.form.controls['email'].value,
        IdPerfil: this.form.controls['profile'].value,
        IdPessoa: this.itemEdit.pessoaId,
      }
    }
  }

  createForm(): void {
    console.log('no forms ', this.itemEdit)
    if (this.isEditing) {
      this.form = this.formBuilder.group({
        role: [this.itemEdit.FuncaoId, [Validators.required]],
        profile: [this.itemEdit.perfilId, [Validators.required]],
        name: [this.itemEdit.nome, [Validators.required]],
        cpf: [this.itemEdit.cpf, [Validators.required]],
        email: [this.itemEdit.email, [Validators.required]],
      })
    } else {
      this.form = this.formBuilder.group({
        role: [this.itemEdit.FuncaoId, [Validators.required]],
        profile: [null, [Validators.required]],
        name: [this.itemEdit.nome, [Validators.required]],
        cpf: [this.itemEdit.cpf, [Validators.required]],
        email: [this.itemEdit.email, [Validators.required]],
      })
    }
    this.form.get('email')?.disable()
    this.form.get('cpf')?.disable()
    this.form.get('name')?.disable()
    this.form.get('role')?.disable()
  }
}
